import { useContext } from 'react';
import { EnterprisesContext } from '../contexts/enterprisesContext';

const useEnterprises = () => {
  const context = useContext(EnterprisesContext);
  if (!context) {
    throw new Error('useEnterprises must be used within a EnterprisesProvider');
  }
  return context;
};

export default useEnterprises;
